import React from "react";

function Subrow(props) {
  return <div style={{ margin: 2, minHeight: 100, position: "relative" }}>{props.children}</div>;
}

export default Subrow;
